import { SWReactIcons } from '@similarweb/icons';

import {
  StyledProgressBar,
  StyledCloseButton,
  StyledStepsCounter,
  StyledOnboardingStepTitle,
  StyledOnboardingStepSubtitle,
} from './styles';

export type StepHeaderProps = {
  onClose(): void;
  onBack(): void;
  stepIndex: number;
  stepsCount: number;
  title: string;
  subtitle: string;
};

export const StepHeader = ({ onClose, onBack, stepsCount, stepIndex, title, subtitle }: StepHeaderProps) => {
  const stepNumber = stepIndex + 1;
  const isFirstStep = stepNumber === 1;
  const getProgressPercentage = () => Number(((stepNumber / stepsCount) * 100).toFixed(1));

  return (
    <>
      <StyledProgressBar progressPercentage={getProgressPercentage()} />
      <StyledCloseButton variant="flat" onClick={isFirstStep ? onClose : onBack}>
        <SWReactIcons iconName={isFirstStep ? 'clear' : 'arrow-left'} size="xs" />
      </StyledCloseButton>
      <StyledStepsCounter>
        <span>{stepNumber}</span>/{stepsCount}
      </StyledStepsCounter>
      <StyledOnboardingStepTitle>{title}</StyledOnboardingStepTitle>
      <StyledOnboardingStepSubtitle>{subtitle}</StyledOnboardingStepSubtitle>
    </>
  );
};
